import { handleActions } from "redux-actions";
import { BULK_MANAGER } from "constants/action-types";
import type { IBulkActionPayload, IBulkJob } from "helpers/utils/bulk-manager";
import _ from "lodash";

export interface IState {
    brandId: string;
    type: string;
    processes: {
        [key: string]: IBulkActionPayload;
    };
    open: boolean;
    errors: Error;
    bulkJob: IBulkJob;
}

export const initialState: IState = {
    brandId: null,
    type: null,
    processes: {},
    open: false,
    errors: null,
    bulkJob: null,
};

export const bulkManagerReducer = handleActions<IState, any>(
    {
        [BULK_MANAGER.OPEN]: (state: IState, { payload }) => {
            return {
                ...state,
                type: payload,
                open: true,
                errors: initialState.errors,
            };
        },
        [BULK_MANAGER.CLOSE]: (state: IState) => {
            return initialState;
        },
        [BULK_MANAGER.ADD]: (state: IState, { payload }) => {
            return {
                ...state,
                processes: {
                    ...state.processes,
                    [payload.id]: payload,
                },
            };
        },
        [BULK_MANAGER.REMOVE]: (state: IState, { payload }) => {
            return {
                ...state,
                processes: _.omit(state.processes, payload.id),
            };
        },
        [BULK_MANAGER.SET_BULK_JOBS]: (state: IState, { payload }) => {
            return {
                ...state,
                bulkJob: payload,
            };
        },
    },
    initialState,
);
